// extracted by mini-css-extract-plugin
export default {"button":"dn7vIP","hidden":"p83JBU"};